export default "__VITE_ASSET__Wvjsu5oi__"